export default "__VITE_ASSET__DKtlDLMh__"